import type { PnlAxisCoverage } from 'src/components/star-grid/pnlAxis.types';
import { IHeaderParams } from 'ag-grid-community';
import { useStarGridText } from 'src/components/star-grid/hooks/useStarGridText';
import React from 'react';
import { displayReportPeriod } from 'src/components/star-grid/utils/pnlStatementGrid';

export const ReportPeriodHeader: React.FC<IHeaderParams & { readonly periodType?: string; readonly coverage?: PnlAxisCoverage }> = ({
  displayName,
  periodType,
  coverage
}) => {
  const text = useStarGridText();
  const periodLabels: Record<string, string> = {
    actual: text('actualPeriodLabel'),
    forecast: text('forecastPeriodLabel'),
    variance: text('variancePeriodLabel'),
    varianceExFx: text('varianceExFxPeriodLabel')
  };
  const partial = coverage && coverage.available_periods.length < coverage.expected_periods.length;
  const periodLabel = periodType ? periodLabels[periodType] ?? periodType : undefined;
  return (
    <div
      className={`sg-report-period${periodType !== undefined || partial ? ' sg-report-period-with-type' : ''}`}
      title={
        coverage
          ? `${displayName} · ${text('studioCoverage')}: ${coverage.available_periods.length}/${coverage.expected_periods.length}`
          : displayName
      }
    >
      <span>{displayReportPeriod(displayName)}</span>
      {partial && <span className="sg-report-period-partial">{text('studioPartial')}</span>}
      {periodType !== undefined && <span className="sg-report-period-type">{periodLabel}</span>}
    </div>
  );
};

export const ReportHierarchyHeader: React.FC<IHeaderParams> = ({ displayName }) => (
  <div className="sg-report-hierarchy-title" title={displayName}>
    {displayName}
  </div>
);
